/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Value
 */
export interface Value {
}

/**
 * Check if a given object implements the Value interface.
 */
export function instanceOfValue(value: object): value is Value {
    return true;
}

export function ValueFromJSON(json: any): Value {
    return ValueFromJSONTyped(json, false);
}

export function ValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): Value {
    return json;
}

export function ValueToJSON(json: any): Value {
    return ValueToJSONTyped(json, false);
}

export function ValueToJSONTyped(value?: Value | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

